<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.GrowingConditions"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | method: 'getSectionHeaderTextColor' : section)
  "
  class="section-header-general section-header-growing-conditions">
  {{ menu | method: 'getTypeColumnTitle' : colVm }}
</div>
